import React from "react";
import styles from "./role-pill.module.scss";

interface RolePillProps {
  role: string;
}

const cssClassName = "role-pill";

export default function RolePill({ role }: RolePillProps) {
  return <div className={styles[cssClassName]}>{role}</div>;
}
